export default function to_lowercase_with_hyphens(a, n) {
  // Converts a string a to lowercase and replaces spaces with hyphens,
  // while retaining first n words.
  return a.split(' ').slice(0, n).join('-').toLowerCase()
}